{
  "rampsPresenter": {
    "title": "Tarmacs – {{fboName}}",
    "stats": {
      "totalRamps": "Tarmacs totaux",
      "totalAircraft": "Total aéronefs au stationnement"
    },
    "columns": {
      "rampName": "Nom du tarmac",
      "currentAircraft": "Aéronef actuel",
      "actions": "Actions"
    },
    "tooltips": {
      "aircraftCount": "Nombre d'aéronefs sur le tarmac"
    },
    "emptyState": {
      "title": "Aucun tarmac",
      "description": "Créez votre premier tarmac pour commencer à gérer le stationnement et la planification des aéronefs."
    },
    "rampRow": {
      "buttons": {
        "currentRamp": "Tarmac actuel",
        "rampSchedule": "Planning du tarmac",
        "editTenants": "Modifier les locataires"
      }
    }
  }
}
